import { render, staticRenderFns } from "./formStep6.vue?vue&type=template&id=33ae83c0&"
import script from "./formStep6.vue?vue&type=script&lang=js&"
export * from "./formStep6.vue?vue&type=script&lang=js&"
import style0 from "./formStep6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports